<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<CostSearchSection
				:query="q"
				:users="users"
				:situations="situations"
				@search-items="searchCosts($event)"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="items"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="renderToPage(item)">
							<!-- TODO 一時的なため変更要 -->
							<td>{{ item.situation }}</td>
							<td>{{ item.formatted_id }}</td>
							<td>{{ item.quotation_number }}</td>
							<td>{{ item.product_category_name }}</td>
							<td>{{ item.matter.team_member_name }}</td>
							<td>{{ item.matter.regular_customer_company.name }}</td>
							<td>{{ item.matter.plant_customer_company ? item.plant_customer_company.name : '' }}</td>
							<td>{{ common.formatDate(item.start_date) }}</td>
							<td>{{ item.budget.toLocaleString() }}</td>
							<td>{{ item.cost.toLocaleString() }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CostSearchSection from "./components/ConstructionCostSearchSection.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		CostSearchSection,
	},
	data() {
		return {
			title: "原価一覧",
			items: [],
			authority_flag: false,
			users: [],
			situations: [],
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				// TODO
			},
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchCosts(this.q, page, true)
	},
	methods: {
		fetchCosts(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/constructions/costs", {
					params,
					headers,
				})
				.then((res) => {
					// this.items = res.data.requirements
					this.items = res.data.requirements.map((r) => {
						r.situation = ["受注", "未受注", "実施済み", "着工済み"][Math.floor(Math.random() * 4)]
            r.formatted_id = `KJ${r.id.toString().padStart(6, "0")}`
            r.quotation_number = `KG70M${r.id.toString().padStart(3, "0")}`
            r.product_category_name = "L"
            r.start_date = '2023-05-01'
            r.budget =  1000 * Math.floor(Math.random() * 2000)
            r.cost =  1000 * Math.floor(Math.random() * 2000)
            return r
					})
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.users = res.data.users
						this.authority_flag = res.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchCosts(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchCosts(q) {
			this.q = q
			this.fetchCosts(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		renderToPage(item) {
			if (!item.costs.length) {
				this.$router.push({ name: "construction_cost_new", params: { id: item.id } })
			} else {
				this.$router.push({ name: "construction_cost_new", params: { id: item.id } })
			}
		},
	},
}

function headers() {
	return [
		{
			text: "状態",
			value: "",
			width: "100px",
		},
		{
			text: "台帳番号",
			value: "",
			width: "100px",
		},
		{
			text: "見積番号",
			value: "",
			width: "120px",
		},
		{
			text: "製品区分",
			value: "",
			width: "100px",
		},
		{
			text: "営業担当",
			value: "",
			width: "100px",
		},
		{
			text: "受注先",
			value: "",
			width: "150px",
		},
		{
			text: "プラントメーカー",
			value: "",
			width: "150px",
		},
		{
			text: "着工予定",
			value: "",
			width: "150px",
		},
		{
			text: "予算総額",
			value: "",
			width: "200px",
		},
		{
			text: "実績総額",
			value: "",
			width: "120px",
		},
	]
}
</script>
